module.exports = __webpack_public_path__ + "img/title-1.5ddc2577.png";